import { TMobileSignupForm } from './form';
import {
  usePostApplicationMutation,
  usePostStateMutation,
} from '../../../api/lendingApi/lendingApiMutations';
import { useGetApplicationQuery } from '../../../api/lendingApi/lendingApiQueries';
import { getInitialApplicationBodyDE } from '../../../helpers/getApplicationBody';
import { getReferralSession } from '../../../helpers/referralSession';
import { useSignupParams } from '../../../hooks/useSignupParams';
import { TGetStartedDataDE } from '../../GetStarted/GetStartedDE/GetStartedDE';
import { getInitialStateBody } from '../../GetStarted/GetStartedUK/GetStartedUK.helpers';

// Creates the account (state + application) once at the email step. No-ops if an
// application already exists so resume/back-nav can't mint a second account.
export const useMobileSignupAccountSetup = () => {
  const { affiliateTag, fromCampaign } = useSignupParams();
  const { application } = useGetApplicationQuery();
  const { mutatePostState } = usePostStateMutation();
  const { mutatePostApplication } = usePostApplicationMutation();

  const setUpAccount = async (form: TMobileSignupForm) => {
    if (application) return;

    const stateKey = await mutatePostState({
      body: getInitialStateBody(affiliateTag, fromCampaign, {
        email: form.email,
      } as TGetStartedDataDE),
    });
    if (!stateKey) throw new Error('POST state returned no state_key');

    await mutatePostApplication({
      stateKey,
      body: getInitialApplicationBodyDE(
        affiliateTag,
        {
          amount: form.amount,
          loanDuration: form.loanDuration || undefined,
          loanPurpose: form.loanPurpose || undefined,
          loanPurposeDetails: form.loanPurposeDetails,
        },
        getReferralSession(),
      ),
    });
  };

  return { setUpAccount };
};
